import { Box } from "@mui/material";

import MyPerformanceSummaryCard from "../widgets/MyPerformanceSummary/MyPerformanceSummaryCard";
import RoleWidgetTabs from "./RoleWidgetTabs";
import { getRoleViewConfig } from "./roleViewConfig";

/**
 * Tabbed My Performance body shared by SALESREP and RBD (same route as other
 * roles). Greeting + product filter live in {@link MyPerformanceHeader}; the
 * hero card and tabs are driven entirely by {@link roleViewConfig}. Returns
 * null for roles without a tabbed config (handled by the legacy grid path).
 */
export default function RoleMyPerformanceView({
  roleKey,
  widgetProps,
  selectedProduct,
}) {
  const config = getRoleViewConfig(roleKey);
  if (!config) return null;

  const summaryProps = config.heroPropsKey
    ? widgetProps?.[config.heroPropsKey]
    : null;

  return (
    <>
      {config.showHero && summaryProps && (
        <Box sx={{ mb: 3 }}>
          <MyPerformanceSummaryCard {...summaryProps} />
        </Box>
      )}

      <RoleWidgetTabs
        roleKey={roleKey}
        config={config}
        widgetProps={widgetProps}
        selectedProduct={selectedProduct}
      />
    </>
  );
}
